import actionCreator from '../../../utils/actionCreator';

const AuthActionTypes = ['SIGN_IN', 'FETCH_USER', 'LOG_OUT'];

export const { types: authTypes, actions: authActions } = actionCreator(AuthActionTypes);
